import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

const addNote = (idCompany: number, causalName: string, note: string) =>
  trackPromise(axios.post<number>('/oCausalNote/insert', { idCompany, causalName, note }), 'module');

const deleteNote = (idNote: number) => trackPromise(axios.post('/oCausalNote/deleteByIdNote', { idNote }), 'module');

export default {
  addNote,
  deleteNote,
};
